import { createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import Types from '../Actions/Types'

export const INITIAL_STATE = Immutable({
    programs: [],
    currentProgram: {},
    startNodes: {},
    currentOrganization: {},
    history: [],
    glossary: [],
    htmlContent: '<p>Fetching data...</p>',
    classes : {},
    boardingTypes: [],
    reqDoc: {
        school: null
    },
    overViewReport: null,
    dmftIndex: null,
    dataUpdateFlag: false,
    currentOrganizationContentId: null,

    plusMetaMeds: [],
    plusMetaSympt: [],
    plusMetaTreat: [],
    plusMetaVitals: []
}) 

const addSchoolContentID = (state, action) => {
    let currentOrganizationContentId = state.currentOrganizationContentId

    if (action.fileGroup === 'school') {
        currentOrganizationContentId = action.contentId
    }

    return state.merge({
        currentOrganizationContentId
    })
}

const formatGlossaryItem = (glossaryItem) =>  JSON.parse(glossaryItem.json_value).data

const sortGlossaryItems = (glossaryItem, nextGlossaryItem) => glossaryItem.contentFirstLetter > nextGlossaryItem.contentFirstLetter ? 1 : -1

const loadReport = (state, action) => {
    return state.merge({
        htmlContent: action.report    
    })
}

const storeProgramList = (state, action) => {
    return state.merge({
        programs: action.payload.programs,
        startNodeMap: action.payload.startNodeMap,
        currentProgram: action.payload.currentProgram,
        history: action.payload.history
    })
}

const changeReportInReducer = (state, action) => state.merge({currentProgram: state.programs.filter(program => program.billing.id === action.billingId)[0]})

const storeOrgClasses = (state, actions) => state.merge({
    classes: actions.classes
})

const storeStudentBoardingType = (state, actions) => state.merge({
    boardingTypes: actions.response
})

const updateDocs = (state, action) => {
    let reqDoc = { ...state.reqDoc }
    reqDoc[action.fileGroup] = action.reqDocs


    return state.merge({
        reqDoc
    })
}

const storeGlossary = (state, action) => state.merge({glossary: Boolean(action.error) ? [] : action.payload.map(formatGlossaryItem).sort(sortGlossaryItems) })

const storeOrganization = (state, action) => state.merge({currentOrganization: action.organization || {}})

const resetOrg = (state, action) => INITIAL_STATE

const storeOverViewReport = (state, action) => {
    return state.merge({
        overViewReport: action.overViewReport
    })

}

const updateDMFTIndex = (state, action) => {

    if(Boolean(action.dmftIndex) && !action.dmftIndex.error) {
        return state.merge({
            dmftIndex: action.dmftIndex
        })
    } else {
        return state.merge({
            dmftIndex: null
        })
    }

}

const toggleDataUpdateFlag = (state, action) => {
        return state.merge({
            dataUpdateFlag: !state.dataUpdateFlag
        })
}

const storeNurseMeta = (state, action) => {
    let resp = action.response.response

    let med = [], sym = [], tre = []
    resp.contents.forEach(element => {
        element.category === 3 
            ? med.push(element.metadata) 
            : element.category === 1 
                ? tre.push(element.metadata)
                : element.category === 2 
                    ? sym.push(element.metadata) 
                    : null
    })

    return state.merge({
        plusMetaMeds: med,
        plusMetaSympt: sym,
        plusMetaTreat: tre,
        plusMetaVitals: resp.vitals
    })
}

const ACTION_HANDLERS = {
    [Types.UPDATE_DOCS]: updateDocs,
    [Types.LOAD_REPORT]: loadReport,
    [Types.RESET_ORG]: resetOrg,
    [Types.STORE_PROGRAM_LIST]: storeProgramList,
    [Types.STORE_CLASSES]: storeOrgClasses,
    [Types.STORE_STUDENT_BOARDING_TYPE]: storeStudentBoardingType,
    [Types.STORE_GLOSSARY]: storeGlossary,
    [Types.STORE_ORGANIZATION]: storeOrganization,
    [Types.STORE_OVERVIEW_REPORT]: storeOverViewReport,
    [Types.UPDATE_DMFT_INDEX]: updateDMFTIndex,
    [Types.CHANGE_REPORT_IN_REDUCER]: changeReportInReducer,
    [Types.TOGGLE_DATA_UPDATE_FLAG]: toggleDataUpdateFlag,
    [Types.ADD_SCHOOL_CONTENT_ID]: addSchoolContentID,
    [Types.STORE_NURSE_META]: storeNurseMeta
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)



// WEBPACK FOOTER //
// ./src/Reducers/OrganizationReducer.js